import React from "react";
import OnePanel from "./OnePanel";
import { Link } from "react-router";

const BusinessCase = props => (
  <OnePanel title="BUSINESS CASE">
    <Link to="/analysis/bcase/executive-summary">
      Start to read
    </Link>{" "}
    MG Business Case.
  </OnePanel>
);

export default BusinessCase;



// WEBPACK FOOTER //
// ./src/components/bcase/BusinessCase.js